import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import {
    RadioRowDiv,
    SurgeryDateView,
    DetailsMainContainer,
    PatientView,
    PatientRowDiv,
    Title,
    MainContainerItems,
} from 'src/pages/scheduleSurgery/components/details/Details.styled';
import { SpaceDiv } from './PatientDetails.styled';
import InputBox from 'src/common/refactoredComponents/input/Input';
import RadioButton from 'src/common/refactoredComponents/RadioButton/RadioButton';
import Datepicker from 'src/common/components/datePicker/DatePicker';
import Calendar from 'src/assets/images/CalendarTodayBlue.svg';
import { useTranslation } from 'react-i18next';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import { getDisplayDate } from 'src/utils/dateUtils';
import {
    MANDATORY,
    VISIBLE,
    // REGEX_WITH_SPECIFIC_CHAR
} from 'src/constants/appConstants';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import { isPatientDetailsPresent } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const PatientDetails = ({
    usageDetails,
    patientDetails,
    setPatientDetails,
    errForEmptyHrefIdField,
    setErrForEmptyHrefIdField,
    errForEmptyPatientField,
    setErrForEmptyPatientField,
    countryCode,
}) => {
    const [expandedCard, setExpandedCard] = useState({
        patient: true,
    });
    const { patient } = expandedCard;

    const {
        patientInformationVisibility,
        patientIdVisibility,
        patientIdMandatory,
        reportUsagePatientDetails,
        reportUsagePatientDetailsMandatory,
    } = useSelector((state) => state.loginReducer);

    const patientDetailsReducer = useSelector(
        (state) => state.reportUsageRootReducer.patientDetails
    );

    const reportUsageObject = useSelector(
        (state) => state.reportUsageRootReducer.reportUsageObject
    );
    //    const [patientVisibilityDetails, setpatientVisibilityDetails] = useState({
    //        patientHospital:true,
    //        patientName: true,
    //        patientSex: true,
    //        patientDOB:true
    //     });
    useEffectWithErrorLogging(() => {
        if (
            usageDetails?.hrefId &&
            !errForEmptyHrefIdField &&
            usageDetails?.patientFirstName &&
            usageDetails?.patientLastName &&
            !errForEmptyPatientField
        ) {
            setExpandedCard({ patient: false });
        } else {
            setExpandedCard({ patient: true });
        }
    }, [usageDetails, errForEmptyHrefIdField]);

    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };
    // useEffectWithErrorLogging(() => {
    //     patientVisibilityDetails
    // }, []);

    // const inputValidation = REGEX_WITH_SPECIFIC_CHAR;
    const { t } = useTranslation();

    // useEffectWithErrorLogging(() => {
    //     const hrefId = patientDetails?.hrefId ? patientDetails.hrefId : '';
    //     if (hrefId !== '' && !inputValidation.test(hrefId)) {
    //         setErrForEmptyHrefIdField(t('common.invalidCharactersError'));
    //     } else {
    //         setErrForEmptyHrefIdField(null);
    //     }
    // }, [patientDetails]);

    return (
        <div style={{ marginBottom: '10px', marginTop: '10px' }}>
            {/* <SubTitleComponent>{t('reportUsage.recordUsageTitle')}</SubTitleComponent> */}
            {(patientIdVisibility === VISIBLE ||
                patientInformationVisibility === VISIBLE ||
                reportUsagePatientDetails?.length) && (
                <CollapsableCard id="reportUsage-patientDetails-patientDetails-patientDetails"
                    padding={
                        patient ? '20px 24px 4px 21px' : '17px 24px 15px 22px'
                    }
                    margin={'0px 2px 0px 1px'}
                    fontFamily={'AvenirNextWorld Demi'}
                    fontWeight={'bold'}
                    title={t('common.patientDetails')}
                    onClick={() => toggleCard('patient', !patient)}
                    isExpanded={patient}
                    currentActivity
                >
                    {patient && (
                        <>
                            <DetailsMainContainer>
                                {patientIdVisibility === VISIBLE &&
                                    reportUsagePatientDetails?.includes(
                                        'href'
                                    ) && (
                                        <MainContainerItems
                                            setMarginBottom={true}
                                            width="42%"
                                        >
                                            <Title
                                                showAstrisk={
                                                    patientIdMandatory === MANDATORY ||
                                                    reportUsagePatientDetailsMandatory?.includes(
                                                        'href'
                                                    )
                                                }
                                            >
                                                {t(
                                                    'common.hospitalPatientReferenceId'
                                                )}
                                            </Title>
                                            <InputBox
                                                name="hrefId"
                                                defaultValue={
                                                    usageDetails?.hrefId
                                                        ? usageDetails?.hrefId
                                                        : patientDetailsReducer.hrefId
                                                }
                                                value={patientDetails?.hrefId}
                                                placeholder={t(
                                                    'common.enterReferenceId'
                                                )}
                                                id={'reportUsage-patientDetails-patientDetails-patientReferenceId'}
                                                onChange={(e) =>
                                                    setPatientDetails({
                                                        ...patientDetails,
                                                        hrefId: e.target.value,
                                                    })
                                                }
                                                disabled={false}
                                                backgroundDisabled={false}
                                                onBlur={(e) =>
                                                    setErrForEmptyHrefIdField(
                                                        // e.target.value?.length > 0
                                                        //     ?
                                                        //     !inputValidation.test(
                                                        //           !e.target.value
                                                        //       )
                                                        //         ? t(
                                                        //               'common.invalidCharactersError'
                                                        //           )
                                                        //         : null
                                                        //     :
                                                        e.target.value?.length <
                                                            1 &&
                                                            (patientIdMandatory ||
                                                                reportUsagePatientDetailsMandatory?.includes(
                                                                    'href'
                                                                ))
                                                            ? t(
                                                                  'orders.reportsAndInvoice.viewReport.Referenceidrequired'
                                                              )
                                                            : null
                                                    )
                                                }
                                                border={
                                                    errForEmptyHrefIdField?.length >
                                                        0 && '2px solid #FACFD6'
                                                }
                                            />
                                            {errForEmptyHrefIdField && (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                    }}
                                                >
                                                    <AlertMsg
                                                        message={
                                                            errForEmptyHrefIdField
                                                        }
                                                        marginLeft={'0px'}
                                                    />
                                                </div>
                                            )}
                                        </MainContainerItems>
                                    )}
                                {patientInformationVisibility === VISIBLE && (
                                    <>
                                        {reportUsagePatientDetails?.includes(
                                            'name'
                                        ) && (
                                            <MainContainerItems
                                                setMarginBottom={true}
                                            >
                                                <Title
                                                    showAstrisk={
                                                        patientIdMandatory ||
                                                        reportUsagePatientDetailsMandatory?.includes(
                                                            'name'
                                                        )
                                                    }
                                                >
                                                    {t(
                                                        'common.patientNameText'
                                                    )}
                                                </Title>
                                                <PatientView>
                                                    <InputBox
                                                        name="patientFirstName"
                                                        defaultValue={
                                                            usageDetails?.patientFirstName
                                                                ? usageDetails?.patientFirstName
                                                                : patientDetailsReducer.patientFirstName
                                                        }
                                                        value={
                                                            patientDetails?.patientFirstName
                                                        }
                                                        id={'reportUsage-patientDetails-patientDetails-patientFirstName'}
                                                        onChange={(e) =>
                                                            setPatientDetails({
                                                                ...patientDetails,
                                                                patientFirstName:
                                                                    e.target
                                                                        .value,
                                                            })
                                                        }
                                                        placeholder={t(
                                                            'common.firstName'
                                                        )}
                                                        disabled={
                                                            usageDetails?.unidId &&
                                                            usageDetails.patientFirstName &&
                                                            usageDetails
                                                                .patientFirstName
                                                                .length > 0
                                                        }
                                                        backgroundDisabled={
                                                            usageDetails?.unidId &&
                                                            usageDetails.patientFirstName &&
                                                            usageDetails
                                                                .patientFirstName
                                                                .length > 0
                                                        }
                                                        ipadWidth="80%"
                                                        widthMob={'150%'}
                                                        onBlur={(e) =>
                                                            setErrForEmptyPatientField(
                                                                (e.target.value.trim()
                                                                    ?.length <
                                                                    1 ||
                                                                    !reportUsageObject?.patientLastName) &&
                                                                    (patientIdMandatory ||
                                                                        reportUsagePatientDetailsMandatory?.includes(
                                                                            'name'
                                                                        ))
                                                                    ? t(
                                                                          'reportUsage.procedure.unidSurgery.SurgeryOrReport.Patientrequired'
                                                                      )
                                                                    : null
                                                            )
                                                        }
                                                        border={
                                                            errForEmptyPatientField?.length >
                                                                0 &&
                                                            '2px solid #FACFD6'
                                                        }
                                                    />

                                                    <PatientRowDiv marginTop="0px">
                                                        <InputBox
                                                            width="70%"
                                                            placeholder={t(
                                                                'common.lastName'
                                                            )}
                                                            marginLeft="5px"
                                                            defaultValue={
                                                                usageDetails?.patientLastName
                                                                    ? usageDetails?.patientLastName
                                                                    : patientDetailsReducer.patientLastName
                                                            }
                                                            value={
                                                                patientDetails?.patientLastName
                                                            }
                                                            id={'reportUsage-patientDetails-patientDetails-patientLastName'}
                                                            onChange={(e) =>
                                                                setPatientDetails(
                                                                    {
                                                                        ...patientDetails,
                                                                        patientLastName:
                                                                            e
                                                                                .target
                                                                                .value,
                                                                    }
                                                                )
                                                            }
                                                            name="patientLastName"
                                                            disabled={
                                                                usageDetails?.unidId &&
                                                                usageDetails.patientLastName &&
                                                                usageDetails
                                                                    .patientLastName
                                                                    .length > 0
                                                            }
                                                            backgroundDisabled={
                                                                usageDetails?.unidId &&
                                                                usageDetails.patientLastName &&
                                                                usageDetails
                                                                    .patientLastName
                                                                    .length > 0
                                                            }
                                                            ipadWidth="155% ! important"
                                                            ipadMarginLeft={'5px'}
                                                            ipadAirWidth={'150%'}
                                                            ipadAirMarginLeft={'5px'}
                                                            ipadProMarginLeft={'5px'}
                                                            ipadProWidth={'150%'}
                                                            widthMob={'100% ! important'}
                                                            mbMarginRight={'10px'}
                                                            onBlur={(e) =>
                                                                setErrForEmptyPatientField(
                                                                    (e.target.value.trim()
                                                                        ?.length <
                                                                        1 ||
                                                                        !reportUsageObject?.patientFirstName) &&
                                                                        (patientIdMandatory ||
                                                                            reportUsagePatientDetailsMandatory?.includes(
                                                                                'name'
                                                                            ))
                                                                        ? t(
                                                                              'reportUsage.procedure.unidSurgery.SurgeryOrReport.Patientrequired'
                                                                          )
                                                                        : null
                                                                )
                                                            }
                                                        />
                                                        <InputBox
                                                            maxLength="1"
                                                            width="25%"
                                                            placeholder={t(
                                                                'common.MI'
                                                            )}
                                                            defaultValue={
                                                                usageDetails?.patientSalutation
                                                            }
                                                            value={
                                                                patientDetails?.patientSalutation
                                                            }
                                                            id={'reportUsage-patientDetails-patientDetails-patientSalutation'}
                                                            onChange={(e) =>
                                                                setPatientDetails(
                                                                    {
                                                                        ...patientDetails,
                                                                        patientSalutation:
                                                                            e
                                                                                .target
                                                                                .value,
                                                                    }
                                                                )
                                                            }
                                                            name="patientSalutation"
                                                            disabled={
                                                                usageDetails?.unidId &&
                                                                usageDetails.patientSalutation &&
                                                                usageDetails
                                                                    .patientSalutation
                                                                    .length > 0
                                                            }
                                                            backgroundDisabled={
                                                                usageDetails?.unidId &&
                                                                usageDetails.patientSalutation &&
                                                                usageDetails
                                                                    .patientSalutation
                                                                    .length > 0
                                                            }
                                                            ipadWidth="70%"
                                                            ipadMarginLeft={'5px'}
                                                            ipadAirWidth={'57%'}
                                                            ipadAirMarginLeft={'5px'}
                                                            ipadProMarginLeft={'5px'}
                                                            ipadProWidth={'57%'}
                                                            mobMarginLeft={'5px'}
                                                        />
                                                    </PatientRowDiv>
                                                </PatientView>
                                                {errForEmptyPatientField && (
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                        }}
                                                    >
                                                        <AlertMsg
                                                            message={
                                                                errForEmptyPatientField
                                                            }
                                                            marginLeft={'0px'}
                                                        />
                                                    </div>
                                                )}
                                            </MainContainerItems>
                                        )}
                                        {reportUsagePatientDetails?.includes(
                                            'sex'
                                        ) && (
                                            <MainContainerItems
                                                setMarginBottom={true}
                                            >
                                                <Title
                                                    showAstrisk={reportUsagePatientDetailsMandatory?.includes(
                                                        'sex'
                                                    )}
                                                >
                                                    {t(
                                                        'common.patientSexLabel'
                                                    )}
                                                </Title>
                                                <RadioRowDiv>
                                                    <RadioButton
                                                        isChecked={
                                                            (usageDetails?.patientSex ==
                                                                'Male' &&
                                                                usageDetails?.unidId) ||
                                                            patientDetails?.patientSex ==
                                                                'Male' ||
                                                            patientDetailsReducer?.patientSex ==
                                                                'Male'
                                                                ? true
                                                                : false
                                                        }
                                                        id={'reportUsage-patient-sexLable-male'}
                                                        label={t('common.M')}
                                                        iPadPaddingRight="38px"
                                                        value={t(
                                                            'scheduleSurgery.details.male'
                                                        )}
                                                        fontFamilyStyle="AvenirNextWorld Regular"
                                                        handleChange={(e) => {
                                                            if (
                                                                !usageDetails?.unidId
                                                            ) {
                                                                setPatientDetails(
                                                                    {
                                                                        ...patientDetails,
                                                                        patientSex:
                                                                            e,
                                                                    }
                                                                );
                                                                patientDetailsReducer.patientSex =
                                                                    e;
                                                            }
                                                        }}
                                                        name="patientSex"
                                                        // disabled={disableFormFields}
                                                        disabled={
                                                            usageDetails?.unidId &&
                                                            usageDetails?.patientSex
                                                        }
                                                    />
                                                    <SpaceDiv />
                                                    <RadioButton
                                                        isChecked={
                                                            (usageDetails?.patientSex ==
                                                                'Female' &&
                                                                usageDetails?.unidId) ||
                                                            patientDetails?.patientSex ==
                                                                'Female' ||
                                                            patientDetailsReducer?.patientSex ==
                                                                'Female'
                                                                ? true
                                                                : false
                                                        }
                                                        id={'reportUsage-patient-sexLable-female'}
                                                        label={t('common.F')}
                                                        handleChange={(e) => {
                                                            if (
                                                                !usageDetails?.unidId
                                                            ) {
                                                                setPatientDetails(
                                                                    {
                                                                        ...patientDetails,
                                                                        patientSex:
                                                                            e,
                                                                    }
                                                                );
                                                                patientDetailsReducer.patientSex =
                                                                    e;
                                                            }
                                                        }}
                                                        value={t(
                                                            'scheduleSurgery.details.female'
                                                        )}
                                                        fontFamilyStyle="AvenirNextWorld Regular"
                                                        name="patientSex"
                                                        // disabled={disableFormFields}
                                                        disabled={
                                                            usageDetails?.unidId &&
                                                            usageDetails?.patientSex
                                                        }
                                                    />
                                                </RadioRowDiv>
                                            </MainContainerItems>
                                        )}
                                        {reportUsagePatientDetails?.includes(
                                            'dob'
                                        ) && (
                                            <MainContainerItems
                                                setMarginBottom={true}
                                            >
                                                <Title
                                                    showAstrisk={reportUsagePatientDetailsMandatory?.includes(
                                                        'dob'
                                                    )}
                                                >
                                                    {t(
                                                        'common.dateofBirthLabel'
                                                    )}
                                                </Title>
                                                <SurgeryDateView>
                                                    <Datepicker
                                                        id={'reportUsage-patient-dob'}
                                                        onChange={(date) =>
                                                            setPatientDetails({
                                                                ...patientDetails,
                                                                patientDOB:
                                                                    getDisplayDate(
                                                                        date,
                                                                        'YYYY-MM-DD'
                                                                    ),
                                                            })
                                                        }
                                                        selectedDateFromDatePicker={
                                                            usageDetails?.patientDOB &&
                                                            usageDetails?.unidId
                                                                ? usageDetails?.patientDOB
                                                                : patientDetails?.patientDOB
                                                                ? patientDetails?.patientDOB
                                                                : patientDetailsReducer?.patientDOB
                                                        }
                                                        datePickerCalendarIcon={
                                                            Calendar
                                                        }
                                                        minDate={
                                                            new Date(1900, 1, 1)
                                                        }
                                                        maxDate={new Date()}
                                                        placeholder={t(
                                                            'dateFormat'
                                                        )}
                                                        fontSize="16px"
                                                        left="10px"
                                                        mobileHeight="40px"
                                                        yearRange={`1900:${new Date().getFullYear()}`}
                                                        disabled={
                                                            usageDetails?.unidId &&
                                                            usageDetails?.patientDOB &&
                                                            usageDetails
                                                                ?.patientDOB
                                                                .length > 0
                                                        }
                                                        datePickerDivMbWidth="60%"
                                                        datePickerBgColor={
                                                            usageDetails?.unidId &&
                                                            usageDetails?.patientDOB
                                                                ? '#F1F1F1'
                                                                : 'unset'
                                                        }
                                                        datePickerDivWidth="180px"
                                                        datePickerDivHeight="40px"
                                                        iconHeight={'auto'}
                                                        reportUsage
                                                        border={
                                                            '2px solid #EBEDED'
                                                        }
                                                        textOpacity={
                                                            usageDetails?.unidId &&
                                                            usageDetails?.patientDOB
                                                                ? 0.5
                                                                : patientDetails?.patientDOB
                                                                ? 1
                                                                : 0.5
                                                        }
                                                        smbWidth={'100%'}
                                                        smbIconPaddingTop={
                                                            '0px'
                                                        }
                                                        smbIconheight={'40px'}
                                                        iconRight='0px'
                                                    />
                                                </SurgeryDateView>
                                            </MainContainerItems>
                                        )}
                                    </>
                                )}
                            </DetailsMainContainer>
                        </>
                    )}
                </CollapsableCard>
            )}
        </div>
    );
};

export default PatientDetails;
